import type { CSSProperties } from 'react';

/** Fixed positioning escapes scrollable tables; open upward near the viewport edge. */
export function rowMenuStyle(anchor: HTMLElement | null, width = 224): CSSProperties {
  const rect = anchor?.getBoundingClientRect();
  const menuWidth = Math.max(0, Math.min(width, window.innerWidth - 16));
  const top = rect?.top ?? 8;
  const bottom = rect?.bottom ?? 8;
  const above = Math.max(0, top - 12);
  const below = Math.max(0, window.innerHeight - bottom - 12);
  return {
    position: 'fixed',
    width: menuWidth,
    left: Math.max(8, Math.min((rect?.right ?? menuWidth + 8) - menuWidth, window.innerWidth - menuWidth - 8)),
    overflowY: 'auto',
    ...(below < Math.min(320, above)
      ? { bottom: window.innerHeight - top + 4, maxHeight: above }
      : { top: bottom + 4, maxHeight: below }),
  };
}
